import { BomItemDetailsTabTypes } from 'features/BomItemDetailsDialog/DetailsTabs/BomItemDetailsTabs'
import { EmbeddedRh24MessageTypes } from 'features/EmbeddedRh24/EmbeddedRh24MessageTypes'
import { useCustomerPortalMessages } from 'features/EmbeddedRh24/useEmbeddedMessages'
import queryString from 'query-string'
import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import type { BomItemDetailsPanelProps } from './BomItemDetailsPanel'

export const useGetDetailsUrl = () => {
  const getDetailsUrl = useCallback(
    (
      initialTab: BomItemDetailsTabTypes | null,
      detailsProps: Partial<BomItemDetailsPanelProps>,
    ) => {
      if (!initialTab) {
        if (document.location.search.includes('tab=')) {
          const queryParams = queryString.parse(document.location.search)
          initialTab = queryParams.tab as BomItemDetailsTabTypes
        }
      }

      const query = queryString.stringify(
        {
          tab: initialTab,
          bomItemId: detailsProps.bomItemPointer?.id,
          bomItemType: detailsProps.bomItemPointer?.type,
          initialAttachmentId: detailsProps.initialAttachmentId,
          pageId: detailsProps.pageId,
          workingStep: detailsProps.workingStep,
          workingStepActivityId: detailsProps.workingStepActivityId,
          financialsTab: detailsProps.financialDetetailsTab,
          resourceId: detailsProps.resourceId,
        },
        {
          skipEmptyString: true,
          skipNull: true,
        },
      )

      return {
        queryString: query,
        fullUrl:
          window.location.origin + window.location.pathname + `?${query}`,
      }
    },
    [],
  )

  return getDetailsUrl
}

export const useBomItemDetailsDialog = () => {
  const navigate = useNavigate()
  const { sendMessage } = useCustomerPortalMessages()
  const getDetailsUrl = useGetDetailsUrl()

  const openBomItemDetailsDialog = useCallback(
    (
      initialTab: BomItemDetailsTabTypes | null,
      detailsProps: Partial<BomItemDetailsPanelProps>,
      openOnANewWindow?: boolean,
    ) => {
      const detailsUrl = getDetailsUrl(initialTab, detailsProps)

      if (detailsUrl.queryString === document.location.search) {
        return
      }

      sendMessage(
        EmbeddedRh24MessageTypes.RH24_EMBEDDED_SEARCH_PARAMS_CHANGED,
        {
          queryString: detailsUrl.queryString,
        },
      )

      if (openOnANewWindow) {
        window.open(detailsUrl.fullUrl, '_blank')
        return
      }

      const navFn = () => {
        navigate(
          {
            search: detailsUrl.queryString,
          },
          {
            state: {
              filesToUpload: detailsProps?.filesToUpload,
            },
          },
        )
      }

      navFn()
    },
    [getDetailsUrl, navigate, sendMessage],
  )

  return openBomItemDetailsDialog
}
